import { HostAppEventHandler } from "../manager/eventManager/HostAppEventHandler";
import { HostAppEvent } from "../manager/eventManager/HostAppEventReceiver";

export class OneNoteEventHandler extends HostAppEventHandler {

  constructor() {
    super();
  }

  public HandleEvent(event: HostAppEvent, eventInfo: any) {
    switch (event) {
      case HostAppEvent.ONENOTE_PAGE_CHANGED:
        this.emit(HostAppEvent[HostAppEvent.ONENOTE_PAGE_CHANGED], eventInfo.oldPageId, eventInfo.newPageId);
        break;
      case HostAppEvent.ONENOTE_PAGE_DELETED:
        this.emit(HostAppEvent[HostAppEvent.ONENOTE_PAGE_DELETED], eventInfo.pageId);
        break;
      case HostAppEvent.ONENOTE_PAGE_MOVED:
        this.emit(HostAppEvent[HostAppEvent.ONENOTE_PAGE_MOVED], eventInfo.newPageId, eventInfo.newSectionId, eventInfo.newNotebookId, eventInfo.newPageHyperLink);
        break;
      case HostAppEvent.ONENOTE_NOTEBOOK_CLOSED:
        this.emit(HostAppEvent[HostAppEvent.ONENOTE_NOTEBOOK_CLOSED], eventInfo.notebookId);
        break;
      default:
        super.HandleEvent(event, eventInfo);
    }
  }
}